<div class="chart-header">
  <div class="label">
    {{ label | translate
    }}<span *ngIf="meterType">
      - {{ meterType | translate }} <span *ngIf="data && data.length">({{ data | accumulatedChartValue : "value" | number : "1.1-1" }} {{ data[0].units }})</span>
    </span>
  </div>
  <div class="spacer"></div>
  <div class="actions">
    <ng-container *ngFor="let action of actions">
      <ng-container [ngTemplateOutlet]="action.template" [ngTemplateOutletContext]="{ data: action.data }"></ng-container>
    </ng-container>
  </div>
</div>
<mat-spinner *ngIf="!dataLoaded" diameter="40"></mat-spinner>
<ng-container *ngIf="dataLoaded" [ngSwitch]="type">
  <div *ngSwitchCase="types.verticalBar" class="chart-container bar">
    <ngx-charts-bar-vertical
      [results]="data"
      [legend]="false"
      [xAxis]="true"
      [yAxis]="true"
      [scheme]="baseColorSchema"
      [animations]="false"
      [showDataLabel]="true"
      [roundEdges]="true"
      [tooltipDisabled]="true"
      [yAxisTickFormatting]="formatVerticalBarChartYAxisLabel"
    >
    </ngx-charts-bar-vertical>
  </div>
  <div *ngSwitchCase="types.horizontalBar" class="chart-container bar">
    <ngx-charts-bar-horizontal
      [results]="data | sortChartData"
      [scheme]="colorScheme"
      [legend]="false"
      [xAxis]="true"
      [yAxis]="true"
      [animations]="false"
      [showDataLabel]="true"
      [roundEdges]="true"
      [tooltipDisabled]="true"
      [trimYAxisTicks]="false"
      [xAxisTickFormatting]="formatHorizontalBarChartXAxisLabel"
    >
    </ngx-charts-bar-horizontal>
  </div>
  <div *ngSwitchCase="types.pie" class="chart-container pie">
    <ngx-charts-pie-chart
      [tooltipDisabled]="true"
      [results]="data"
      [scheme]="colorScheme"
      [legend]="true"
      legendTitle=""
      [animations]="false"
      [labels]="true"
      [labelFormatting]="formatPieChartLabel"
      [trimLabels]="false"
      [doughnut]="true"
      [arcWidth]="0.4"
    >
    </ngx-charts-pie-chart>
  </div>
</ng-container>
